import ProcessTimeline from "@/components/SelfProcessTimeline";
import CommonModal from "@/components/ui/CommonModal";
import {
  FlowFormPanelLayout,
  FormSectionLayout,
} from "@/components/ui/FlowFormPanel/FlowFormPanel";
import { FlowModalTitle } from "@/components/ui/FlowModalTitle";
import { useTranslation } from "react-i18next";
import { useModal } from "@/hooks/modals/useModal";
import { useFlowNodeQuery } from "@/hooks/services/useFlow";
import { Form } from "antd";
import { useBlockRecordDetailQuery } from "../../hooks/useBlockRecordDetailQuery";
import { useFormFooter } from "../../hooks/useFormFooter";
import { useInitFormFields } from "../../hooks/useInitFormFields";
import type { BlockApplyFormFields } from "../../type";
import { BlockApplyForm } from "../BlockApplyForm";
import styles from "./BlockApplyModal.module.less";
import { FREEZE_APPLY_TYPE } from "@/constants";

export const BlockApplyModal = () => {
  const { t } = useTranslation("supplierProfile");
  const { open, closeModal, props } = useModal("MATERIAL_BLOCK");
  const { recordId, isFlowFinished, flowStatus, isReadOnly } = props;

  const detail = useBlockRecordDetailQuery(recordId);
  const [form] = Form.useForm<BlockApplyFormFields>();

  const timeLineItems = useFlowNodeQuery(detail?.insId);

  const cleanup = () => {
    closeModal();
    form.resetFields();
  };

  const renderFooter = useFormFooter(form, cleanup);

  useInitFormFields(form, detail);

  const showFlowStatusRules = [
    isReadOnly,
    flowStatus !== "已通过" &&
      detail?.applyType === FREEZE_APPLY_TYPE.PENDING_SUBMISSION,
    flowStatus !== "已通过" &&
      detail?.applyType === FREEZE_APPLY_TYPE.UNDER_APPROVAL,
  ];

  const showFlowStatus = showFlowStatusRules.some((r) => r);

  return (
    <CommonModal
      title={
        <FlowModalTitle
          title={t("供应商信息")}
          processCode={detail?.processCode}
        />
      }
      open={open}
      onCancel={cleanup}
      width={1100}
      centered
      className={styles.flowModalWrapper}
      footer={null}
    >
      <FlowFormPanelLayout
        leftPanel={
          <FormSectionLayout
            body={<BlockApplyForm form={form} />}
            footer={renderFooter(detail)}
          ></FormSectionLayout>
        }
        rightPanel={
          <ProcessTimeline
            items={timeLineItems}
            showFinishedFlag={isFlowFinished}
          />
        }
        showRightPanel={showFlowStatus && timeLineItems.length > 0}
      ></FlowFormPanelLayout>
    </CommonModal>
  );
};
